import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';

/**
 *  SAJÁT KRÉTA-HOZZÁFÉRÉS (pedagógus).
 *
 *  A KRÉTA-szinkron a tanár nevében lép be a KRÉTA-ba, ezért mindenkinek a SAJÁT
 *  belépési adatait kell megadnia. Ez a képernyő kizárólag a bejelentkezett dolgozó
 *  adatát mutatja és írja – a többiek adatait csak az admin összesítő látja.
 *
 *  A jelszót és a kétlépcsős kulcsot sosem olvassuk vissza: a szerver csak azt
 *  jelzi, hogy VAN-e beállítva. Üresen hagyva a korábbi megmarad, tehát a
 *  felhasználónév önmagában is módosítható.
 */
@Component({
  selector: 'app-kreta-sajat',
  templateUrl: './kreta-sajat.component.html',
  styleUrls: ['./kreta-sajat.component.scss'],
})
export class KretaSajatComponent implements OnInit {
  intezmenyId = '';
  allomany = '';
  tanarNev = '';
  toltodik = false;
  mentes = false;
  ellenorzes = false;
  /** Az ellenőrzés eredménye: { ok, uzenet | error, nem_naplozott }. */
  eredmeny: any = null;

  adat: any = null;
  urlap: any = { kreta_user: '', kreta_pass: '', kreta_totp: '' };

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    this.intezmenyId = (await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId;
    const meta: any = await this.data.getFromStorage('userMetadata');
    this.allomany = String(meta?.adid || meta?.username || '');
    this.tanarNev = `${meta?.viselt_vez || ''} ${meta?.viselt_ker || ''}`.trim();
    await this.betolt();
  }

  async betolt() {
    if (!this.allomany || !this.intezmenyId) return;
    this.toltodik = true;
    try {
      this.adat = await firstValueFrom(this.http.get(
        `/api/naplo-kreta-naploz/sajat/${encodeURIComponent(this.allomany)}/${this.intezmenyId}`));
      this.urlap.kreta_user = this.adat?.kreta_user || '';
      // A beállítottság a bal menü piros jelzését is vezérli.
      await this.data.setStorage('kretaBeallitva', !!this.adat?.beallitva);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A beállítás betöltése nem sikerült.', 'error');
    } finally {
      this.toltodik = false;
    }
  }

  /**
   *  Belépés-próba a KRÉTÁ-ba a megadott adatokkal.
   *
   *  A mentés nem bizonyít semmit: a rossz jelszó vagy a rossz 2FA-kulcs csak a
   *  következő szinkronon derülne ki. Ezért itt tényleg belépünk – az éppen begépelt
   *  adattal, MENTÉS ELŐTT is. Amit nem írtál be, azt a szerver a tároltból veszi.
   */
  async ellenoriz() {
    const user = this.urlap.kreta_user?.trim();
    if (!user) {
      this.data.sendToast('Add meg a KRÉTA felhasználóneved.', 'warning');
      return;
    }
    if (!this.urlap.kreta_pass && !this.adat?.van_jelszo) {
      this.data.sendToast('Add meg a jelszavad – enélkül nincs mit ellenőrizni.', 'warning');
      return;
    }
    this.ellenorzes = true;
    this.eredmeny = null;
    try {
      this.eredmeny = await firstValueFrom(this.http.post('/api/naplo-kreta-naploz/sajat-teszt', {
        intezmeny: this.intezmenyId,
        allomany: this.allomany,
        kreta_user: user,
        kreta_pass: this.urlap.kreta_pass || undefined,
        kreta_totp: this.urlap.kreta_totp || undefined,
      }));
      this.data.sendToast(
        this.eredmeny?.ok ? 'A KRÉTA-belépés sikerült.' : 'A KRÉTA-belépés nem sikerült.',
        this.eredmeny?.ok ? 'success' : 'error');
    } catch (e: any) {
      this.eredmeny = { ok: false, error: e?.error?.error || 'Az ellenőrzés nem futott le.' };
      this.data.sendToast(this.eredmeny.error, 'error');
    } finally {
      this.ellenorzes = false;
    }
  }

  async ment() {
    if (!this.urlap.kreta_user?.trim()) {
      this.data.sendToast('Add meg a KRÉTA felhasználóneved.', 'warning');
      return;
    }
    this.mentes = true;
    try {
      await firstValueFrom(this.http.post('/api/naplo-kreta-naploz/sajat', {
        intezmeny: this.intezmenyId,
        allomany: this.allomany,
        tanar_nev: this.tanarNev || null,
        kreta_user: this.urlap.kreta_user.trim(),
        kreta_pass: this.urlap.kreta_pass || undefined,
        kreta_totp: this.urlap.kreta_totp || undefined,
      }));
      this.data.sendToast('Mentve.', 'success');
      this.urlap.kreta_pass = '';
      this.urlap.kreta_totp = '';
      // A mentett adat már nem az, amit az eredmény igazolt – tiszta lappal indulunk.
      this.eredmeny = null;
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.mentes = false;
    }
  }
}
